import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { reportInvalidCard } from 'modules/accommodations/features/reservations/api';

export const useMutationReportInvalidCard = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(reportInvalidCard, {
    onSuccess: data => {
      if (data.success) successToast(t('Invalid card successfully reported'));
    },
    onError: () => errorToast(),
  });
};
